import { AutoStack } from 'components'
import { FieldArray } from 'formik'
import { FormikTextField } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { ParticipantInsertInput } from 'model'
import { DefaultButton, IconButton, Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export interface ProvingDetailsSupplierFormValues {
  participants: ParticipantInsertInput[]
}

export class ProvingDetailsSupplierFormSchema {
  constructor() {
    return Yup.object().shape({
      participants: Yup.array().of(
        Yup.object().shape({
          unknownPerson: Yup.object().shape({
            firstName: Yup.string().trim().required('Name ist ein Pflichtfeld'),
            surName: Yup.string().trim().required('Name ist ein Pflichtfeld'),
            supplier: Yup.string().trim().required('Firma ist ein Pflichtfeld'),
            email: Yup.string()
              .trim()
              .email('Ungültiges E-Mail-Format')
              .required('E-Mail ist ein Pflichtfeld'),
          }),
        })
      ),
    })
  }
}

export const ProvingDetailsSupplierForm: React.FC<{
  orderIds: string[]
}> = ({ orderIds }) => {
  const { t } = useTranslation()

  return (
    <FormStack>
      <Label>{t('Lieferant / Sonstiges hinzufügen')}</Label>
      <>
        <FieldArray name="participants">
          {({ form, name, ...helpers }) => {
            const values: {
              percentage: number
              orderId: string
            }[] = form.values[name]
            if (values.length === 0) {
              helpers.push({ percentage: 100, orderId: '' })
            }
            return (
              <AutoStack tokens={{ childrenGap: 12 }}>
                {values.map((x: any, i: number) => (
                  <FieldStack key={i} horizontal={true}>
                    <FieldStackItem
                      label={t('Vorname')}
                      name={`participants[${i}].unknownPerson.firstName`}
                      required={true}
                      component={FormikTextField}
                    />
                    <FieldStackItem
                      label={t('Nachname')}
                      name={`participants[${i}].unknownPerson.surName`}
                      required={true}
                      component={FormikTextField}
                    />
                    {/* <FieldStackItem
                      label={t('Name')}
                      name={`participants[${i}].unknownPerson.employee`}
                      required={true}
                      component={FormikTextField}
                    /> */}
                    <FieldStackItem
                      label={t('Firma')}
                      name={`participants[${i}].unknownPerson.supplier`}
                      required={true}
                      component={FormikTextField}
                    />
                    <FieldStackItem
                      label={t('E-Mail')}
                      name={`participants[${i}].unknownPerson.email`}
                      required={true}
                      component={FormikTextField}
                    />
                    <IconButton
                      styles={{
                        root: { color: 'red', marginTop: 'auto' },
                      }}
                      iconProps={{ iconName: 'Delete' }}
                      onClick={() => helpers.remove(i)}
                    />
                  </FieldStack>
                ))}
                <DefaultButton
                  text={'+'}
                  onClick={() => {
                    helpers.push({
                      percentage: 100,
                      orderId: '',
                    })
                  }}
                />
              </AutoStack>
            )
          }}
        </FieldArray>
      </>
    </FormStack>
  )
}
